import React from 'react';
import { TableCell, TableHead, TableRow } from '@material-ui/core';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';

// noinspection JSAnnotator
const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
    }),
)(TableCell);

/**
 * Release plan header.
 * @param props
 * @returns {*}
 * @constructor
 */
function ReleaseTableHeader(props) {
    const { t } = props;
    return (
        <TableHead>
            <TableRow>
                <StyledTableCell align="center">{t('test')}</StyledTableCell>
                <StyledTableCell align="center">{t('question')}</StyledTableCell>
                <StyledTableCell align="center">{t('time_in_minute')}</StyledTableCell>
                <StyledTableCell align="center">{t('available_from')}</StyledTableCell>
                <StyledTableCell align="center">{t('available_till')}</StyledTableCell>
                <StyledTableCell align="center">{t('START_TEST')}</StyledTableCell>
            </TableRow>
        </TableHead>
    );
}

export default ReleaseTableHeader;
